import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import VerticalStack from 'Components/ComponentLibrary/Atoms/Layout/VerticalStack';
import StackItem from 'Components/ComponentLibrary/Atoms/Layout/StackItem';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Container from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Container';
import WhatIfClientDisclaimer from 'Components/ComponentLibrary/Organisms/WhatIfClientDisclaimer';
import { pickFunction } from 'Helpers/Affordances';

const TabContainer = ({ children, collection, resource }) => {
  const clientDisclaimerResource = pickFunction(resource, {
    [fr.relationships.clientDisclaimer.name]: () => {
      const [includedResourceIdentifier] = resource.relationship(
        fr.relationships.clientDisclaimer.name,
      ).data;

      return collection.included().findResource(includedResourceIdentifier);
    },
    [fr.relationships.default.name]: () => null,
  });

  return (
    <Container disableGutters maxWidth="sm">
      <Box marginBottom={3}>
        <VerticalStack spacing={3}>
          <StackItem>{children}</StackItem>
          <StackItem hidden={clientDisclaimerResource === null}>
            {clientDisclaimerResource !== null ? (
              <Container maxWidth="sm">
                <WhatIfClientDisclaimer resource={clientDisclaimerResource} />
              </Container>
            ) : null}
          </StackItem>
        </VerticalStack>
      </Box>
    </Container>
  );
};

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  collection: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
};

export default TabContainer;
